export default __webpack_public_path__ + "static/media/icon-redirect-2.193f7133.svg";